import React from 'react'
import "./Spinner.css";

const Spinner = () => {
  return (
    <div className='grid justify-items-center w-[100%] h-screen'>
      <div className='spinner'></div>
    </div>
  )
}

export default Spinner